import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClapboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconClapboard"><Path d="M17.25 3.75H6.75C5.09315 3.75 3.75 5.09315 3.75 6.75V17.25C3.75 18.9069 5.09315 20.25 6.75 20.25H17.25C18.9069 20.25 20.25 18.9069 20.25 17.25V6.75C20.25 5.09315 18.9069 3.75 17.25 3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><Path d="M4 8.75H20" stroke="currentColor" strokeWidth="1.5"/><Path d="M8.25 8.75L10.25 3.75" stroke="currentColor" strokeWidth="1.5"/><Path d="M13.75 8.75L15.75 3.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
});

export default IconClapboard;
